<template>
<v-dialog
    v-model="dialog"
    max-width="700"
>
    <v-card>
        <v-card-title>{{title}} ({{timezone}})</v-card-title>

        <v-card-text>

            <v-row>
                <v-col>
                    <v-date-picker v-model="date">

                    </v-date-picker>
                </v-col>

                <v-col>
                    <v-time-picker
                        v-model="time"
                        ampm-in-title
                    >
                    </v-time-picker>
                </v-col>
            </v-row>

            <slot name="dialog-warning" :date="date" :time="time" />

        </v-card-text>

        <v-card-actions>

            <v-btn
                text
                @click="onClickUnset"
                v-if="optional"
            >
                Unset
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="ok_disabled"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
import { DateTime } from 'luxon';

export default {

    props: {
        title: {
            type: String,
            default: function() { return 'Title'; }
        },

        value: {
            type: Number,
            default: function() { return null; }
        },

        optional: {
            type: Boolean,
            default: function() { return false; }
        },

        timezone: {
            type: String,
            default: function() { return 'America/Phoenix'; }
        },

        disable_ok_fn: {
            type: Function,
            default: () => false
        },
    },

    data() {
        return {
            dialog: false,

            date: null,
            time: null,
        }
    },

    methods: {

        showDialog(set_time, set_timezone)
        {
            let value = this.value;
            let timezone = this.timezone;

            if ( set_time != null ) value = set_time;
            if ( set_timezone != null ) timezone = set_timezone;

            if ( value == null )
            {
                this.date = null;
                this.time = null;
            }
            else
            {
                let dt = DateTime.fromMillis(value).setZone(timezone);
                this.date = dt.toISODate();

                this.time = dt.toLocaleString(DateTime.TIME_24_SIMPLE);
            }

            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
            this.$emit('ok', this.value_millis);
        },

        onCancel()
        {
            this.dialog = false;
        },

        onClickUnset()
        {
            this.dialog = false;
            this.$emit('ok', null);
        }

    },

    computed: {
        ok_disabled()
        {
            if (this.date == null || this.time == null) return true;
            if (this.disable_ok_fn && typeof this.disable_ok_fn === 'function') {
                return this.disable_ok_fn(this.date);
            }
            return false;
        },

        pretty_date() 
        {
            if ( this.value == null ) return null;

            let dt = DateTime.fromMillis(this.value).setZone(this.timezone);

            return dt.toISODate();
        },

        value_millis()
        {
            if ( this.date == null ) return null;
            if ( this.time == null ) return null;

            let dpart = this.date.split("-");
            let tpart = this.time.split(":");

            let obj = {
                'year' : parseInt(dpart[0]),
                'month' : parseInt(dpart[1]),
                'day' : parseInt(dpart[2]),
                'hour' : parseInt(tpart[0]),
                'minute' : parseInt(tpart[1]),
            };

            let dt = DateTime.fromObject(obj, { zone: this.timezone, numberingSystem: 'beng'});

            return dt.toMillis();
        }
    },
}
</script>

<style lang="scss" scoped>
</style>